module.exports = __webpack_public_path__ + "img/09_lala-azizli.6cb8fe4e.jpg";